import { camelCase } from 'lodash';

import { recursiveCaseTransform } from './recursiveCaseTransform';
import type { JSONData } from './types';

export function toCamelCase<T extends JSONData>(sourceObj: JSONData): T {
  return recursiveCaseTransform<T>(sourceObj, camelCase);
}
